import React from 'react';

const Logo = ({ src }) => <img className="logo" src={src} alt="HAKI logo" />;

export default Logo;